import Vue from 'vue'
import Vuex from 'vuex'
import {
	stripePk,
	demoNRDS
} from '@/properties'
const axios = require('axios');
import {
	serverUrl,
	worbixServerUrl,
	commonServiceUrl,
	adminEmail,
	slsServerUrl,
	customerUrl
} from '../properties';

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		agentInfo: {},
		brokrageInfo: {},
		franchiseeEmail: 'email.me@contata.co.in',
		spaceName: 'OnBoardMe',
		spaceId: null,
		orgTitle: 'PrintedAgent',
		siteId: 159,
		stripePk: stripePk,
		brokerage:null,
		basicProfile:null,
		stripeObj: Stripe(stripePk)
	},
	mutations: {
		setAgent: (state, data) => {
			state.agentInfo = data
		},
		setBroker: (state, data) => {
			state.brokrageInfo = data
		},
		updateSpaceDetails: (state, data) => {
			let spaceInfo = (data.invitation && data.invitation.sentTo) ? data.invitation.sentTo : null
			if (spaceInfo && spaceInfo.resourceSpace) {
				state.spaceId = spaceInfo.resourceSpace.id;
			}
			if (spaceInfo && spaceInfo.profiles && spaceInfo.profiles.length) {
				state.basicProfile = spaceInfo.profiles.filter((item)=>{
					return item.type == "com.worbix.model.BasicProfile";
				})[0];
			}
		},
		updateBasicProfile: (state, data) => {
			state.basicProfile = data.basicProfile ? data.basicProfile : null;
			state.brokerage = data.brokerage ? data.brokerage : null;
			state.spaceId = data.agentSpace ? data.agentSpace.id : null;
		}
	},
	actions: {
		getAgentData: async({ commit, state, getters }, payload) => {
			let agentData = (await axios.post(`${serverUrl}/offices/GETAGENT`, payload)).data
			return agentData;
		},
		getOfficeData: async({ commit, state, getters }, payload) => {
			let agentData = (await axios.post(`${serverUrl}/offices/GETOFFICEBYID`, payload)).data
			return agentData;
		},
		createStripeToken: async ({ rootState, dispatch }, payload) => {
			let result = null;
			result = await rootState.stripeObj.createToken(payload.data)
			if (result.error)
				return {
					message: result.error.message
				}
			else {
				return result
			}
		},
		getPrintTemplateList: ({ commit, state, getters }) => {
			return new Promise((resolve, reject) => {

				let payload = {
					"requestContext": {
						"siteId": 158,
						"spaceId": 8121,
						"actorId": 9175,
						"resourceType": "print"
					}
				}

				axios({
					url: worbixServerUrl + 'cxf/public/printCampaignPublicService/list',
					method: 'POST',
					data: payload,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		fetchInvitation :({ commit, state, getters }, payload) =>{
			if (payload.code && payload.code == demoNRDS) {
				return new Promise((resolve, reject) => {
					axios({
						url: './json/invitation.json',
						method: 'GET',
						responseType: 'json'
					}).then((response) => {
						commit('updateSpaceDetails', response.data);
						resolve(response.data)
					}).catch((error) => {
						console.log(error)
					})
				})
			}else {
				return new Promise((resolve, reject) => {
					axios({
						url: worbixServerUrl + 'cxf/rs/signUp/acceptInvitation/' + payload.code,
						method: 'GET',
						responseType: 'json'
					}).then((response) => {
						commit('updateSpaceDetails', response.data);
						resolve(response.data)
					}).catch((error) => {
						console.log(error)
					})
				})
			}
		},
		reInviteAgent :({ commit, state, getters }, payload) =>{
			return new Promise((resolve, reject) => {
				axios({
					url: worbixServerUrl + 'cxf/public/onboarding/reInviteAgent',
					method: 'POST',
					data: payload,
					responseType: 'json'
				}).then((response) => {
					commit('updateSpaceDetails', response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		fakeBrokerageInvite :({ commit, state, getters }, payload) =>{
			return new Promise((resolve, reject) => {
				axios({
					url: worbixServerUrl + 'cxf/public/onboarding/inviteForDemoBrokerage',
					method: 'POST',
					data: payload,
					responseType: 'json'
				}).then((response) => {
					commit('updateSpaceDetails', response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		verifyInvitation :({ commit, state, getters }, payload) =>{
			if (payload.code && payload.code == demoNRDS) {
				return ({'actor':{'contact':{'id' : demoNRDS}}})
			}else {
				return new Promise((resolve, reject) => {
					axios({
						url: worbixServerUrl + 'cxf/rs/signUp/verifiedInvitation',
						method: 'POST',
						data: payload,
						responseType: 'json'
					}).then((response) => {
						resolve(response.data)
					}).catch((error) => {
						console.log(error)
					})
				})
			}
		},
		getBasicProfile :({commit, state, getters }, payload) =>{
			return new Promise((resolve, reject) => {
				axios({
					url: worbixServerUrl + 'cxf/public/onboarding/getBasicProfile/' + payload.personId,
					method: 'GET',
					responseType: 'json'
				}).then((response) => {
					commit('updateBasicProfile', response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		authenticateUser : ({commit, state}, args) =>{
			let auth = window.btoa(args.userName + ":" + args.password);
			let headers = {
				"Authorization": "Basic " + auth,
				"Accept": "application/json",
				"Referer": worbixServerUrl,
				"Content-Type": "application/json"
			}
			let payload = {}
			payload.clientId = 'rvjkrbj0rdsbbdam6nm1e4mv891414618650517' ;
			payload.clientSecret = 'qv35v0nupl3vbcu9mkjtf0ubii1414618650517';
			payload.redirectURI = '/';
			let uri = worbixServerUrl + 'cxf/auth/authorize/decision'
			return new Promise((resolve, reject) => {
				axios({
					url: uri,
					method: 'POST',
					data: payload,
					headers:headers,
					responseType: 'json'
				}).then((jsonData) => {
					console.log('login res', jsonData);
					resolve(jsonData.data)
				}).catch((e) => {
					console.log('login error', e);
					reject(e);
				})
			});
		},
		updateProfile :({commit, state, getters}, payload) =>{
			return new Promise((resolve, reject) => {
				axios({
					url: worbixServerUrl + 'cxf/public/onboarding/createNewSenderProfile',
					method: 'POST',
					data: payload,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		createCustomer :({commit, state, getters}, payload) =>{
			return new Promise((resolve, reject) => {
				axios({
					url: customerUrl + '/sls/source',
					method: 'POST',
					data: payload,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		sentMailToAdmin :({commit, state, getters}, payload) =>{
			console.log({adminEmail});
			let params = {
					'receiver': [adminEmail],
					'content': payload.mailContent,
					'subject': 'Onboarding Support Needed',
					'action': 'SEND'
				}
			return new Promise((resolve, reject) => {
				axios({
					url: commonServiceUrl + '/ses-push',
					method: 'POST',
					data: params,
					responseType: 'json'
				}).then((response) => {
					console.log('mail response', response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		notifyAdmin :({commit, state, getters}, payload) =>{
			console.log({adminEmail});
			let params = {
					'receiver': [adminEmail],
					'content': payload.mailContent,
					'subject': 'Onboarding Agent Registration',
					'action': 'SEND'
				}
			return new Promise((resolve, reject) => {
				axios({
					url: commonServiceUrl + '/ses-push',
					method: 'POST',
					data: params,
					responseType: 'json'
				}).then((response) => {
					console.log('mail response', response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		uploadProfileImage: ({commit, state, getters}, data) => {
			return new Promise((resolve, reject) => {

				let fileName = 'uploaded_image.png';
				let resourceTemplate = 'com.worbix.contact.template.model.PersonTemplate';

				if (data.name) {
					fileName = data.name ;
				}
				let params = {
					'fileName': fileName,
					'resourceId': data.resourceId,
					'postId': data.resourceId,
					'thumbnailHeight': 200,
					'thumbnailWidth': 200,
					'resourceTemplateClass': resourceTemplate,
					'dataUrl': window.encodeURIComponent(data.file),
					'urlType': 'data'
				}
				axios({
					url: worbixServerUrl + '/cxf/rs/publicService/uploadFilesByBody',
					method: 'POST',
					data: params,
					responseType: 'json'
				}).then((response) => {
					resolve (response.data)
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		setDomainCookie: ({commit, state, getters}, data) => {
			return new Promise((resolve, reject) => {
				let cookieString = '';
				axios({
					url: worbixServerUrl + '/cxf/public/public/setCookie?' + data.cookieString,
					method: 'GET',
					responseType: 'json'
				}).then((response) => {
					resolve (response.data)
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		fetchTeamForOfficeId : async({commit, state, getters}, payload) => {
			let teamsList = (await axios.post(`${slsServerUrl}/account/account/getTeamSpaceList`, payload)).data
			return teamsList;
		},
		sendConfirmationCode: ({commit, state, getters}, params) => {
			return new Promise((resolve, reject) => {
				axios({
					url: slsServerUrl + '/account/verification/sendCode' ,
					method: 'POST',
					data: params,
					responseType: 'json'
				}).then((response) => {
					resolve (response.data)
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		verifyConfirmationCode: ({commit, state, getters}, params) => {
			return new Promise((resolve, reject) => {
				axios({
					url: slsServerUrl + '/account/verification/verifyCode' ,
					method: 'POST',
					data: params,
					responseType: 'json'
				}).then((response) => {
					// console.log({response});
					resolve (response.data)
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		checkIfAgentExists: ({commit, state, getters}, data) => {
			return new Promise((resolve, reject) => {
				let cookieString = '';
				axios({
					//url: worbixServerUrl + 'cxf/public/onboarding/fetchAgentIfExists/' + data.agentKey +'/'+ data.officeId,
					url: slsServerUrl + '/account/account/fetchAgentIfExists/' + data.agentKey ,
					method: 'GET',
					responseType: 'json'
				}).then((response) => {
					resolve (response.data)
				}).catch((error) => {
					console.log(error)
				})
			})
		},

	},
	modules: {}
})
